import { render, staticRenderFns } from "./supplierRemark.vue?vue&type=template&id=2dc9117b&scoped=true"
import script from "./supplierRemark.vue?vue&type=script&lang=js"
export * from "./supplierRemark.vue?vue&type=script&lang=js"
import style0 from "./supplierRemark.vue?vue&type=style&index=0&id=2dc9117b&prod&scoped=true&lang=css"
import style1 from "./supplierRemark.vue?vue&type=style&index=1&id=2dc9117b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc9117b",
  null
  
)

export default component.exports